import { createInput, MountTarget, newDialog, readConfig } from './utils/elements';

export const VISUELE_VOLGORDE_EDIT_SELECTOR = '.cds-lrn-visual-order';

interface VisueleVolgordeConfig {
  amount: number;
  withTrailingContent: boolean;
}

export function visueleVolgordeDialog(
  insertHtml: (html: string) => void,
  mountTarget?: MountTarget,
  existingEl?: HTMLElement
) {
  const dialog = newDialog('Visuele volgorde maken', () => insertHtml(''), mountTarget);

  const withTrailingContent = createInput('trailingContent', 'Voorafgaande inhoud', 'checkbox');
  const amount = createInput('amount', 'Aantal rijen (max 10)', 'number');
  amount.field.setAttribute('min', '1');
  amount.field.setAttribute('max', '10');

  if (existingEl) {
    const cfg = readConfig<VisueleVolgordeConfig>(existingEl, { amount: 1, withTrailingContent: false });
    if (cfg.amount) amount.setValue(cfg.amount);
    withTrailingContent.setChecked(!!cfg.withTrailingContent);
  }

  dialog.querySelector('#cds-dialog-content').append(amount.field, withTrailingContent.field);

  dialog.addEventListener('onSubmit', () => {
    const config: VisueleVolgordeConfig = {
      amount: +amount.value(),
      withTrailingContent: withTrailingContent.checked(),
    };
    insertHtml(makeOrderedTable(config));
  });
}


const clips = [
  'star',
  'square',
  'triangle',
  'diamond',
  'down-arrow',
  'circle',
  'rhombus',
  'upside-down-triangle',
  'ellipsis',
  'pentagon',
];

function makeOrderedTable(config: VisueleVolgordeConfig) {
  const amount = config.amount > 10 ? 10 : config.amount;
  const withTrailingContent = config.withTrailingContent;

  const table = document.createElement('table');
  table.classList.add('cds-lrn-visual-order', 'cds-visual-order');
  table.setAttribute('data-cb-config', JSON.stringify(config));

  const cell = (valign: string = 'middle') => {
    const cell = document.createElement('td');
    cell.classList.add('p-3xs');
    cell.style.verticalAlign = valign;
    return cell;
  };

  for (let i = 0; i < amount; i++) {
    const row = document.createElement('tr');

    const inidicatorCell = cell();
    const indicator = document.createElement('div');
    indicator.classList.add(`order-bg-color-${i + 1}`);
    if (!['square', 'circle', 'ellipsis'].includes(clips[i])) {
      indicator.classList.add(`clip-${clips[i]}`);
    } else if (clips[i] === 'circle') {
      indicator.classList.add('corner-full');
    }

    indicator.style.width = '24px';
    indicator.style.height = '24px';
    if (clips[i] === 'ellipsis') {
      indicator.style.width = '12px';
      indicator.style.marginInline = 'auto';
      indicator.style.borderRadius = '50%';
    }
    inidicatorCell.append(indicator);

    row.append(inidicatorCell);

    if (withTrailingContent) {
      const trailingCell = cell();
      trailingCell.innerHTML = 'voorafgaand';
      row.append(trailingCell);
    }

    const responseCell = cell();
    responseCell.innerHTML = 'placeholder';

    row.append(responseCell);

    table.append(row);
  }

  return table.outerHTML;
}
